import {Injectable} from '@angular/core';
import {AppConstants} from "./app-constant";

@Injectable()
export class Helper {
  static capitalize(string: any) {
    if (!string) return "";
    string = String(string).toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static capitalizeFirstWord(string: any) {
    let splitStr = string.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  static removeObject(arr, attr, value) {
    let i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  static mapTwoArrays(primaryArr, secondaryArr, primaryArrkey, secondaryArrKey, statusKey) {
    if (primaryArr && primaryArr.length > 0) {
      primaryArr.forEach((item: any) => {
        item[statusKey] = false;
        if (secondaryArr && secondaryArr.length > 0) {
          secondaryArr.forEach((dt: any) => {
            if (dt && dt[secondaryArrKey] == item[primaryArrkey]) {
              item[statusKey] = true;
            }
          });
        }
      });
      return primaryArr;
    } else {
      return [];
    }
  }

  static updateArray(primaryArr, changedArr, id) {
    if (primaryArr && primaryArr.length > 0) {
      primaryArr.forEach((items: any, key: any) => {
        if (items.id === id) {
          for (const obj in changedArr) {
            primaryArr[key][obj] = changedArr[obj];
          }
        }
      });
    }
    return primaryArr;
  }

  static formatDate(date: any): any {
    let d: any = new Date(date),
      month: any = '' + (d.getMonth() + 1),
      day: any = '' + d.getDate(),
      year: any = d.getFullYear();
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return [year, month, day].join('-');
  }

  static uniqueArray(array: any, key: any): any {
    const arr: Set<any> = new Set();
    return array.filter((item: { [x: string]: any; }) => {
      if(item[key]){
        const value = item[key];
        if (arr.has(value)) {
          return false;
        } else {
          arr.add(value);
          return true;
        }
      }
    });
  }

  static addDaysWithDate(date, days) {
    let currentDate = new Date(date);
    currentDate.setDate(currentDate.getDate() + days);
    let year = currentDate.getFullYear();
    let month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    let day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  static removeDuplicates(arr, key) {
    const seen = new Set();
    const uniqueArr = [];

    arr.forEach(item => {
      if (!seen.has(item[key])) {
        seen.add(item[key]);
        uniqueArr.push(item);
      }
    });
    return uniqueArr;
  }

  static filterArray(array: any, conditions: any) {
    return array.filter((item: any) => {
      return Object.keys(conditions).every(key => {
        return item[key] === conditions[key];
      });
    });
  }

  static findCommonElements(arr1: any, arr2: any) {
    const set = new Set(arr1);
    return arr2.some((element: any) => set.has(element));
  }

  static workingDaysCheck(workingDays: any) {
    return workingDays && !Object.values(workingDays).every(day => day === 'WEEKLY_OFF');
  }

  static charge_type(type: any) {
    if (type === "ONE_TIME")
      return "One Time";
    else
      return "Yearly";
  }

  static room_type(room: any) {
    if (room === "NON_AC")
      return "Non AC";
    else
      return "AC";
  }

  static scholarshipType(type: any) {
    if (type === "GOVERNMENT") return "Government";
    else return "Non Government";
  }

  static appliedSession(pcbs: any, session: any) {
    return pcbs.filter(pcb =>
      pcb.applied_session?.some(applied => applied.session_id.toString() === session.toString())
    );
  }


  static actualFeeYear(student: any, year: any) {
    const year_name: string = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'][year];
    let total_fee: number = 0;
    total_fee += AppConstants.feeKeys.reduce((sum: any, key: any) => sum + ((student[year_name + '_year_' + key]) ? Number(student[year_name + '_year_' + key]) : 0), 0);
    const year_names: string = ['ist', 'second', 'third', 'fourth', 'fifth', 'sixth'][year];
    const hostel_component: any = JSON.parse(student[year_names + '_year_hostel_components']);
    total_fee += (hostel_component && hostel_component['hostel'] && hostel_component['hostel'].actual_room_charge) ? Number(hostel_component['hostel'].actual_room_charge) : 0;
    total_fee += (hostel_component && hostel_component['hostel'] && hostel_component['hostel'].actual_mess_charge) ? Number(hostel_component['hostel'].actual_mess_charge) : 0;
    total_fee += (hostel_component && hostel_component['hostel'] && hostel_component['hostel'].actual_caution_charge) ? Number(hostel_component['hostel'].actual_caution_charge) : 0;
    total_fee += (hostel_component && hostel_component['hostel'] && hostel_component['hostel'].actual_security_charge) ? Number(hostel_component['hostel'].actual_security_charge) : 0;
    const vehicle_component: any = JSON.parse(student[year_names + '_year_vehicle_components']);
    total_fee += (vehicle_component && vehicle_component['vehicle'] && vehicle_component['vehicle'].actual_vehicle_charges) ? Number(vehicle_component['vehicle'].actual_vehicle_charges) : 0;
    return total_fee;
  }

  static discountFeeYear(student: any, year: any) {
    const year_name: string = ['ist', 'second', 'third', 'fourth', 'fifth', 'sixth'][year];
    const getComponentFee = (component: any, key: string) => component && component[key] ? Number(component[key]) : 0;
    if (student && student[year_name + '_year_fee_components']) {
      const fee_component: any = JSON.parse(student[year_name + '_year_fee_components']);
      const hostel_component: any = JSON.parse(student[year_name + '_year_hostel_components']);
      const vehicle_component: any = JSON.parse(student[year_name + '_year_vehicle_components']);
      let total_fee: number = 0;
      total_fee += AppConstants.feeKeys.reduce((sum: any, key: any) => sum + getComponentFee(fee_component, key), 0);
      if (hostel_component && hostel_component['hostel']) {
        total_fee += ['room_charge', 'mess_charge', 'caution_charge', 'security_charge'].reduce((sum, key) => sum + getComponentFee(hostel_component['hostel'], key), 0);
      }
      if (vehicle_component && vehicle_component['vehicle']) {
        total_fee += getComponentFee(vehicle_component['vehicle'], 'vehicle_charges');
      }
      return total_fee;
    }
    return 0;
  }

  static actualComponentFeeYear(student: any, year: number): number | false {
    const yearName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'][year];

    if (!student?.[`${yearName}_year_tuition_fee`]) {
      return false;
    }

    return AppConstants.feeKeys.reduce((sum, key) => sum + (Number(student?.[`${yearName}_year_${key}`]) || 0), 0);
  }

  static isGreater(end: string, currentDate: string, currentTime: string): boolean {
    const current = new Date(`${currentDate}T${this.to24(currentTime)}:00`);
    return current > new Date(end.replace(' ', 'T'));
  }

  static isLess(start: string, currentDate: string, currentTime: string): boolean {
    const current = new Date(`${currentDate}T${this.to24(currentTime)}:00`);
    return current < new Date(start.replace(' ', 'T'));
  }

  static isBetween(start: string, end: string, currentDate: string, currentTime: string): boolean {
    const current = new Date(`${currentDate}T${this.to24(currentTime)}:00`);
    return current >= new Date(start.replace(' ', 'T')) && current <= new Date(end.replace(' ', 'T'));
  }

  static to24(time12h: string): string {
    const [time, mod] = time12h.split(' ');
    let [h, m] = time.split(':').map(Number);
    h = mod === 'PM' && h !== 12 ? h + 12 : mod === 'AM' && h === 12 ? 0 : h;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
  }

  static getStatusTicketClass(status: any): string {
    const statusClasses = {
      'PENDING': 'text-indigo-800',
      'ON_HOLD': 'text-purple-800',
      'REJECTED': 'text-red-800',
      'RESOLVED': 'text-green-800',
    };
    return statusClasses[status] || '';
  }

  static ticketStatus(status: any): string {
    if (status === "PENDING") return "Pending";
    else if (status === "ON_HOLD") return "On Hold";
    else if (status === "REJECTED") return "Rejected";
    else if (status === "RESOLVED") return "Resolved";
    else return "";
  }

  static convertHourFormat(time: any): string {
    let [hours, minutes, seconds] = time.split(':').map(Number);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
  }

  static permissionCheck(available: any, permission: any) {
    return available.some(element => permission.includes(element)) || available.includes('ALL');
  }

  static childPermissionCheck(child: any, permission: any) {
    return child.some(element => element['availableTo'].some(e => permission.includes(e)) || element['availableTo'].includes('ALL'));
  }

  static capitalizeWords(string: any) {
    if(string){
      return string.toLowerCase().trim().split(/\s+/).map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    } else {
      return "-";
    }
  }

  static feeComponentYearWiseFeeTotal(components: any, year: any): any {
    const component: any = components.find((component: any) => component.year === year);
    if(component) {
      return AppConstants.feeComponentKeys.reduce((total_fee: any, key: any) => total_fee + (component[key] ? parseFloat(component[key]) : 0), 0);
    }
    return 0;
  }

  static actualFee(student: any, year: any): any {
    const yearNames: any = ['first_year', 'second_year', 'third_year', 'fourth_year', 'fifth_year', 'sixth_year'][year];
    return AppConstants.feeComponentKeys.reduce((total: any, key: any) => total + parseFloat((student[`${yearNames}_${key}`]) || 0), 0);
  }

  static discountFee(component: any): any {
    const components: any = component ? JSON.parse(component) : null;
    return AppConstants.feeComponentKeys.reduce((total: any, key: any) => {
      const value: any = components?.[key];
      return value ? total + parseFloat(value) : total;
    }, 0);
  }

  static actualHostelFee(component: any): any {
    const components: any = component ? JSON.parse(component) : null;
    return AppConstants.actualHostelComponentKeys.reduce((total: any, key: any) => {
      const value: any = components?.hostel?.[key];
      return value ? total + parseFloat(value) : total;
    }, 0);
  }

  static discountHostelFee(component: any): any {
    const components: any = component ? JSON.parse(component) : null;
    return AppConstants.discountHostelComponentKeys.reduce((total: any, key: any) => {
      const value: any = components?.hostel?.[key];
      return value ? total + parseFloat(value) : total;
    }, 0);
  }

  static actualVehicleFee(component: any): any {
    const components: any = component ? JSON.parse(component) : null;
    return (components && components['vehicle'] && components['vehicle']['actual_vehicle_charges']) ? parseFloat(components['vehicle']['actual_vehicle_charges']) : 0
  }

  static discountVehicleFee(component: any): any {
    const components: any = component ? JSON.parse(component) : null;
    return (components && components['vehicle'] && components['vehicle']['vehicle_charges']) ? parseFloat(components['vehicle']['vehicle_charges']) : 0
  }

  static transformText(value: any): any {
    return value.toLowerCase().split('_').map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  static convertStudentProcessType(input: any): string {
    if(input){
      return input.toLowerCase().split('_').map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
    return "-";
  }

  static yearWiseActualTotalFee(student: any, year: any): any {
    if(!student || year < 0 || year > 7) return 0;
    let total_fee: any = 0;
    const feeYear: any = ['first_year', 'second_year', 'third_year', 'fourth_year', 'fifth_year', 'sixth_year', 'seventh_year', 'eighth_year'][year];
    const feeKeys: any = ['tuition_fee', 'rcf', 'erp_pdp_fee', 'registration_fee', 'prospectus_fee', 'examination_fee', 'alumni_council_charges', 'digital_skill_course_charges', 'placement_cell_charges',
      'science_and_tech_charges', 'sports_facilities_charges', 'annual_day_charges', 'university_tshirt_charges', 'training_and_industrial_visit_charges', 'academic_security_fee'];
    for (const field of feeKeys) {
      const key = `${feeYear}_${field}`;
      total_fee += student[key] ? parseFloat(student[key]) : 0;
    }
    const hostelVehicleYear: any = ['ist_year', 'second_year', 'third_year', 'fourth_year', 'fifth_year', 'sixth_year', 'seventh_year', 'eighth_year'][year];
    const hostelKey = `${hostelVehicleYear}_hostel_components`;
    const hostelComponent: any[] = Array.isArray(student[hostelKey]) ? student[hostelKey] : [];
    const hostelFields: any = ['actual_caution_charge', 'actual_mess_charge', 'actual_room_charge', 'actual_security_charge'];
    total_fee += hostelComponent?.reduce((sum: number, item: any) => {
      return sum + hostelFields.reduce((subtotal: any, field: any) => subtotal + parseFloat(item[field] || 0), 0);
    }, 0) || 0;
    const vehicleKey = `${hostelVehicleYear}_vehicle_components`;
    const vehicleComponent: any[] = Array.isArray(student[vehicleKey]) ? student[vehicleKey] : [];
    const vehicleFields: any = ['actual_vehicle_charges'];
    total_fee += vehicleComponent?.reduce((sum: number, item: any) => {
      return sum + vehicleFields.reduce((subtotal: any, field: any) => subtotal + parseFloat(item[field] || 0), 0);
    }, 0) || 0;
    return total_fee;
  }

  static yearWiseDiscountTotalFee(student: any, year: any): any {
    if(!student || year < 0 || year > 7) return 0;
    let total_fee: any = 0;
    const feeYear: any = ['ist_year', 'second_year', 'third_year', 'fourth_year', 'fifth_year', 'sixth_year', 'seventh_year', 'eighth_year'][year];
    const feeKey = `${feeYear}_fee_components`;
    const feeComponent: any = student[feeKey] ? student[feeKey] : null;
    const feeFields: any = ['tuition_fee', 'rcf', 'erp_pdp_fee', 'registration_fee', 'prospectus_fee', 'examination_fee', 'alumni_council_charges', 'digital_skill_course_charges', 'placement_cell_charges',
      'science_and_tech_charges', 'sports_facilities_charges', 'annual_day_charges', 'university_tshirt_charges', 'training_and_industrial_visit_charges', 'academic_security_fee'];
    for (const field of feeFields) {
      total_fee += feeComponent && feeComponent[field] ? parseFloat(feeComponent[field]) : 0;
    }
    const hostelKey = `${feeYear}_hostel_components`;
    const hostelComponent: any[] = Array.isArray(student[hostelKey]) ? student[hostelKey] : [];
    const hostelFields: any = ['caution_charge', 'mess_charge', 'room_charge', 'security_charge'];
    total_fee += hostelComponent?.reduce((sum: number, item: any) => {
      return sum + hostelFields.reduce((subtotal: any, field: any) => subtotal + parseFloat(item[field] || 0), 0);
    }, 0) || 0;
    const vehicleKey = `${feeYear}_vehicle_components`;
    const vehicleComponent: any[] = Array.isArray(student[vehicleKey]) ? student[vehicleKey] : [];
    const vehicleFields: any = ['vehicle_charges'];
    total_fee += vehicleComponent?.reduce((sum: number, item: any) => {
      return sum + vehicleFields.reduce((subtotal: any, field: any) => subtotal + parseFloat(item[field] || 0), 0);
    }, 0) || 0;
    return total_fee;
  }

  static getTerm(term: string): any {
    if(term === "APR_SEP"){
      return "July - December";
    } else if(term === "OCT_MAR"){
      return "January - June"
    } else {
      return "-";
    }
  }

  static getYear(year: any): any {
    const years: any = {
      1: 'First',
      2: 'Second',
      3: 'Third',
      4: 'Fourth',
      5: 'Fifth',
      6: 'Sixth',
      7: 'Seventh',
      8: 'Eighth',
    }
    return years[year] || '';
  }

  static getGovtPhotoIdType(type: string, number?: any): any {
    if(type === "AADHAAR" && number === 1) {
      return "Aadhaar Front";
    } else if(type === "AADHAAR" && number === 2) {
      return "Aadhaar Back";
    } else if(type === "DRIVING_LICENCE" && (number === 1 || number === 2)) {
      return "Driving Licence";
    } else if(type === "VOTER_ID" && number === 1) {
      return "Voter Id Front";
    } else if(type === "VOTER_ID" && number === 2) {
      return "Voter Id Back";
    } else if(type === "PASSPORT" && number === 1) {
      return "Passport Front";
    } else if(type === "PASSPORT" && number === 2) {
      return "Passport Front";
    } else {
      return "Other";
    }
  }

  static getAllegationIncidentStatus(status: any): string {
    if(status === "PENDING") {
      return "Pending";
    } else if(status === "APPROVED_BY_HOD") {
      return "Approved By HOD";
    } else if(status === "APPROVED_BY_REGISTRAR") {
      return "Approved By Registrar";
    } else if(status === "APPROVED_BY_ADMIN") {
      return "Approved By Admin";
    } else if(status === "REJECTED_BY_HOD") {
      return "Rejected By HOD";
    } else if(status === "REJECTED_BY_REGISTRAR") {
      return "Rejected By Registrar";
    } else if(status === "REJECTED_BY_ADMIN") {
      return "Rejected By Admin";
    } else {
      return "-";
    }
  }

  static getLeaveType(type: string): any {
    if(type === "CL") return "Casual Leave";
    else if(type === "ML") return "Medical Leave";
    else if(type === "EL") return "Earned Leave";
    else if(type === "SL") return "Sick Leave";
    else if(type === "LWP") return "Leave Without Pay";
    else return "Other";
  }

  static getSubjectType(type: string): any {
    if(type === "THEORY") return "Theory";
    else if(type === "PRACTICAL") return "Practical";
    else if(type === "SEMINAR") return "Seminar";
    else if(type === "MAJOR_PROJECT") return "Major Project";
    else if(type === "MINOR_PROJECT") return "Minor Project";
    else if(type === "DISSERTATION") return "Dissertation";
    else if(type === "TRAINING") return "Training";
    else if(type === "PROBLEM") return "Problem";
    else return "-";
  }

  static getMiscellaneousFee(type: any): any {
    if(type === "OTHER_FEE") return "Other Fee";
    else if(type === "EXAMINATION_FEE") return "Examination Fee";
    else if(type === "PROSPECTUS_FEE") return "Prospectus Fee";
    else if(type === "REVALUATION") return "Revaluation";
    else if(type === "FINE") return "Fine";
    else if(type === "HOSTEL_STAY") return "Hostel Stay";
    else if(type === "ID_CARD") return "ID Card";
    else if(type === "RE_CHECKING") return "Re-Checking";
    else if(type === "CONVOCATION_FEE") return "Convocation Fee";
    else if(type === "UNIFORM") return "Uniform";
    else if(type === "ALUMNI_REGISTRATION") return "Alumni Registration";
    else if(type === "ALLEGATION") return "Allegation";
    else return type;
  }

  static stringFormat(input: string): string {
    if (!input) return "";
    return input
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
